var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopUsersOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shop_users",
    transform: "translate(-168.223 -453.614)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1446",
    "data-name": "Rectangle 1446",
    width: 48,
    height: 48,
    transform: "translate(168.223 453.614)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "shop",
    d: "M4.9,1.578A1.651,1.651,0,0,1,6.159,1h14.1a1.651,1.651,0,0,1,1.255.578L25.822,6.6a2.477,2.477,0,0,1,.6,1.611v.421A3.921,3.921,0,0,1,19.4,11.044a3.922,3.922,0,0,1-6.192,0,3.922,3.922,0,0,1-6.192,0A3.921,3.921,0,0,1,0,8.636V8.215A2.477,2.477,0,0,1,.6,6.6L4.905,1.576ZM7.843,8.636a2.27,2.27,0,1,0,4.541,0,.826.826,0,0,1,1.651,0,2.27,2.27,0,1,0,4.541,0,.826.826,0,0,1,1.651,0,2.27,2.27,0,1,0,4.541,0V8.215a.826.826,0,0,0-.2-.537L20.259,2.651H6.159L1.849,7.679a.826.826,0,0,0-.2.537v.421a2.27,2.27,0,1,0,4.541,0,.826.826,0,0,1,1.651,0ZM2.477,13.383a.826.826,0,0,1,.826.826v9.907H4.953V15.86A1.651,1.651,0,0,1,6.6,14.209h4.953a1.651,1.651,0,0,1,1.651,1.651v8.256h9.907V14.209a.826.826,0,0,1,1.651,0v9.907h.826a.826.826,0,1,1,0,1.651H.826a.826.826,0,1,1,0-1.651h.826V14.209A.826.826,0,0,1,2.477,13.383ZM6.6,24.116h4.953V15.86H6.6ZM14.86,15.86a1.651,1.651,0,0,1,1.651-1.651h3.3a1.651,1.651,0,0,1,1.651,1.651v4.953a1.651,1.651,0,0,1-1.651,1.651h-3.3a1.651,1.651,0,0,1-1.651-1.651Zm4.953,0h-3.3v4.953h3.3Z",
    transform: "translate(168.305 455.787)",
    fill: "#fc4b77"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-user",
    "data-name": "Icon feather-user",
    transform: "translate(194.223 462.921)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    d: "M26.441,28.853a.809.809,0,0,1-.809-.809v-.389a4.291,4.291,0,0,0-4.286-4.286H11.155a4.286,4.286,0,0,0-4.286,4.286v.389a.809.809,0,0,1-1.619,0v-.389a5.9,5.9,0,0,1,5.9-5.9H21.345a5.911,5.911,0,0,1,5.9,5.9v.389A.809.809,0,0,1,26.441,28.853Z",
    transform: "translate(-5.25 -7.543)",
    fill: "#fc4b77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    d: "M17.155,3.75h0a5.9,5.9,0,1,1-5.9,5.9A5.911,5.911,0,0,1,17.155,3.75Zm0,10.191a4.286,4.286,0,1,0,0-8.572h0a4.286,4.286,0,1,0,0,8.572Z",
    transform: "translate(-6.155 -3.75)",
    fill: "#fc4b77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-user-2",
    "data-name": "Icon feather-user",
    transform: "translate(183.571 474.397)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1060-2",
    "data-name": "Path 1060",
    d: "M26.105,28.741a.8.8,0,0,1-.8-.8v-.383a4.223,4.223,0,0,0-4.218-4.218H11.061a4.218,4.218,0,0,0-4.218,4.218v.383a.8.8,0,0,1-1.593,0v-.383a5.811,5.811,0,0,1,5.811-5.811H21.091A5.818,5.818,0,0,1,26.9,27.561v.383A.8.8,0,0,1,26.105,28.741Z",
    transform: "translate(-5.25 -7.768)",
    fill: "#fc4b77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1061-2",
    "data-name": "Path 1061",
    d: "M17.061,3.75h0A5.811,5.811,0,1,1,11.25,9.561,5.818,5.818,0,0,1,17.061,3.75Z",
    transform: "translate(-6.235 -3.75)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1061-3",
    "data-name": "Path 1061",
    d: "M17.061,3.75h0A5.811,5.811,0,1,1,11.25,9.561,5.818,5.818,0,0,1,17.061,3.75Zm0,10.029a4.218,4.218,0,1,0,0-8.436h0a4.218,4.218,0,1,0,0,8.436Z",
    transform: "translate(-6.235 -3.75)",
    fill: "#fc4b77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1060-3",
    "data-name": "Path 1060",
    d: "M26.105,28.741a.8.8,0,0,1-.8-.8v-.383a4.223,4.223,0,0,0-4.218-4.218H11.061a4.218,4.218,0,0,0-4.218,4.218v.383a.8.8,0,0,1-1.593,0v-.383a5.811,5.811,0,0,1,5.811-5.811H21.091A5.818,5.818,0,0,1,26.9,27.561v.383A.8.8,0,0,1,26.105,28.741Z",
    transform: "translate(-5.25 -7.768)",
    fill: "#fc4b77"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopUsersOutline);
export default __webpack_public_path__ + "static/media/shop_users_outline.5c41966753ef96934713739ea05133c2.svg";
export { ForwardRef as ReactComponent };